import { Toaster } from "./components/ui/toaster.jsx";
import { TooltipProvider } from "./components/ui/tooltip.jsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index.jsx";
import CategoryPage from "./pages/CategoryPage.jsx";
import SignIn from "./pages/SignIn.jsx";
import SignUp from "./pages/SignUp.jsx";
import PostItem from "./pages/PostItem.jsx";
import ItemDetails from "./pages/ItemDetails.jsx";
import PasswordRecovery from "./pages/PasswordRecovery.jsx";
import NotFound from "./pages/NotFound.jsx";
import ChatPage from "./pages/ChatPage.jsx";
import ProfilePage from "./pages/Profile.jsx";
import ProtectedRoute from "./contexts/ProtectedRoute";
import Inbox from "./pages/Inbox";
import About from "./pages/About";
import PrivacyPolicy from "./pages/Privacy";
import HowItWorksPage from "./pages/HowItWorks";
import EditItem from "./pages/EditItem";
import { NotificationProvider } from "./contexts/NotificationContext.jsx";
import { ChatSocketProvider } from "./contexts/ChatSocketContext.jsx";
import { CartProvider } from "./contexts/CartContext.jsx";
import SearchPage from "./pages/SearchPage.jsx";
import CartPage from "./pages/CartPage.jsx";
import AdminRoute from "./contexts/AdminRoute.jsx";
import AdminUsers from "./pages/admin/AdminUsers.jsx";
import AdminUserDetails from "./pages/admin/AdminUserDetails.jsx";
import AdminNotices from "./pages/admin/AdminNotices.jsx";
import NoticeDetails from "./pages/NoticeDetails.jsx";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const saved = localStorage.getItem("theme") || "";
    const media = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );

    if (saved) {
      document.documentElement.classList.toggle(
        "dark",
        saved === "dark"
      );
      return;
    }

    const applyTheme = () => {
      document.documentElement.classList.toggle(
        "dark",
        media.matches
      );
    };

    applyTheme();
    media.addEventListener(
      "change",
      applyTheme
    );

    return () =>
      media.removeEventListener(
        "change",
        applyTheme
      );
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <ChatSocketProvider>
            <NotificationProvider>
              <CartProvider>
            <Routes>
              
              <Route path="/" element={<Index />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route
                path="/notices/:noticeId"
                element={<NoticeDetails />}
              />

              <Route element={<ProtectedRoute />}>
                <Route path="/post" element={<PostItem />} />
                
                <Route path="/cart" element={<CartPage />} />
                <Route path="/inbox" element={<Inbox />} />
                <Route path="/edit-item/:itemId" element={<EditItem />} />
                <Route path="/chat/:itemId/:sellerId" element={<ChatPage />} />
              </Route>

              <Route path="/profile" element={<ProfilePage />} />
              
              <Route element={<AdminRoute />}>
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/users/:userId" element={<AdminUserDetails />} />
                <Route path="/admin/notices" element={<AdminNotices />} />
              </Route>

              <Route path="/category/:slug/:type" element={<CategoryPage />} />
              <Route path="/item/:id" element={<ItemDetails />} />
              <Route path="/reset-password" element={<PasswordRecovery />} />
              <Route path="*" element={<NotFound />} />

            </Routes>

            <Toaster />
              </CartProvider>
            </NotificationProvider>
          </ChatSocketProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
